import { useState } from 'react'

function groupThousands(intDigits: string): string {
  return intDigits.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

/**
 * Поле ввода суммы в ₽ с живыми разделителями разрядов (1000000 → «1 000 000»).
 * Пустое поле = значение null (при очистке остаётся пустым, не «0»). Допускает
 * копейки через запятую (до 2 знаков). Неконтролируемое: хранит строку отображения,
 * наружу отдаёт число|null.
 */
export function MoneyInput({
  value,
  onChange,
  placeholder,
  autoFocus,
  className,
}: {
  value: number | null
  onChange: (v: number | null) => void
  placeholder?: string
  autoFocus?: boolean
  className?: string
}) {
  const [text, setText] = useState(() =>
    value == null ? '' : value.toLocaleString('ru-RU', { maximumFractionDigits: 2 }),
  )

  const handle = (raw: string) => {
    const hasSep = /[.,]/.test(raw)
    const cleaned = raw.replace(/[^\d.,]/g, '').replace(',', '.')
    const [intPartRaw = '', decPartRaw = ''] = cleaned.split('.')
    const intDigits = intPartRaw.replace(/\D/g, '')
    const decDigits = decPartRaw.replace(/\D/g, '').slice(0, 2)

    let display = intDigits ? groupThousands(intDigits) : ''
    if (hasSep) display = `${display || '0'},${decDigits}`
    setText(display)

    if (intDigits === '' && decDigits === '' && !hasSep) {
      onChange(null)
      return
    }
    onChange(Number(`${intDigits || '0'}.${decDigits || '0'}`))
  }

  return (
    <input
      type="text"
      inputMode="decimal"
      className={className ?? 'w-full rounded border border-gray-300 px-2 py-1.5'}
      placeholder={placeholder}
      autoFocus={autoFocus}
      value={text}
      onChange={(e) => handle(e.target.value)}
    />
  )
}
